import './EntityLabels.scss';

const ProjectLabel = ({project, company, small = false}) => (
    <span className={"entity-label entity-label--project " + (small ? 'entity-label--project--small' : '')}>
        <span className="entity-label__body">
            <span className="entity-label__name">{project.title}</span>
            {company && <span className="entity-label__tag">{company.name}</span>}
        </span>
    </span>
);

export default ProjectLabel;